import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { HeaderWithDescription } from '../../../../modules/common/headerWithDescription/HeaderWithDescription';
import { ACDLPublicApi } from '../../../routes/config/ExternalLinks';

export const IntegrationsHeader = (): ReactElement => {
  const { t } = useTranslator();
  const headerDescription = (): ReactElement => (
    <span>
      {t('full_acdl_api_documentation_you_can_find_on')}
      <a
        href={ACDLPublicApi.Documentation.Path}
        target='_blank'
        rel='noreferrer'
      >
        <span> {t('api_documentation')} </span>
      </a>
      {t('page')}
    </span>
  );

  return (
    <HeaderWithDescription
      header={t('your_api_keys')}
      description={headerDescription()}
    />
  );
};
